export default function slider() {
  const promiseTargets = {
    'js-inview': '-inview',
    'js-imageloaded': '-imageloaded',
  };
  const promiseTargetsKeys = Object.keys(promiseTargets);

  document.querySelectorAll('.js-slider').forEach((element) => {
    const slideNodeList = element.querySelectorAll('.splide__slide');

    if (slideNodeList.length < 2) return;

    const splideInstance = new Splide(element, {
      type: 'fade',
      rewind: true,
      speed: 2500,
      arrows: true,
      pagination: false,
      autoplay: true,
      interval: 5000,
      pauseOnHover: false,
    });

    splideInstance.mount();

    if (splideInstance.options.autoplay) {
      if (promiseTargetsKeys.some((className) => element.closest(`.${className}`) !== null)) {
        splideInstance.Components.Autoplay.pause();

        const promiseItems = [];

        promiseTargetsKeys.forEach((className) => {
          promiseItems.push(
            new Promise((resolve) => {
              const targetElement = element.closest(`.${className}`);

              if (targetElement === null) resolve();

              const isDone = () => targetElement.classList.contains(`${promiseTargets[className]}`);

              if (isDone()) {
                resolve();
              } else {
                const observer = new MutationObserver(() => {
                  if (isDone()) {
                    observer.disconnect();
                    resolve();
                  }
                });

                observer.observe(targetElement, {
                  attributes: true,
                  attributeFilter: ['class'],
                });
              }
            }),
          );
        });

        Promise.all(promiseItems).then(() => {
          splideInstance.Components.Autoplay.play();
        });
      }
    }
  });
}
